var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgParallelArrows = function SvgParallelArrows(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#807D7D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m13.69 8-4.813 5.107c-.392.416-.588.624-.744.562s-.143-.342-.118-.904l.081-1.772M10.31 16l4.813-5.107c.392-.416.588-.624.744-.562s.143.342.117.904l-.08 1.772"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#807D7D",
    strokeWidth: 1.5,
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z"
  })));
};
export default SvgParallelArrows;